import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Calculator, Clock, FileCheck } from 'lucide-react';
import { formatCurrency } from '@/lib/utils';

export const GovtServicesCatalogTab = ({ services, deptIcons, onCalculateFee, onGetTimeline, onGetDocuments, onSelectService }) => {
  return (
    <div className="space-y-6">
      <Accordion type="single" collapsible className="w-full">
        {Object.entries(services).map(([deptCode, deptData]) => {
          const Icon = deptIcons[deptCode];
          return (
            <AccordionItem key={deptCode} value={deptCode}>
              <AccordionTrigger className="hover:no-underline">
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-slate-100">
                    <Icon className="w-5 h-5" />
                  </div>
                  <span className="font-semibold">{deptData.name}</span>
                  <Badge variant="secondary">{deptData.services?.length || 0} services</Badge>
                </div>
              </AccordionTrigger>
              <AccordionContent>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-4">
                  {deptData.services?.map((svc) => (
                    <Card key={svc.code} className="hover:shadow-md transition-shadow">
                      <CardContent className="pt-6">
                        <h4 className="font-semibold mb-2">{svc.name}</h4>
                        <div className="space-y-2 text-sm">
                          <div className="flex justify-between">
                            <span className="text-muted-foreground">Base Fee:</span>
                            <span className="font-mono font-semibold">{formatCurrency(svc.base_fee)}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-muted-foreground">Processing:</span>
                            <span>{svc.processing_days} days</span>
                          </div>
                        </div>
                        <div className="flex gap-2 mt-4">
                          <Button variant="outline" size="sm" onClick={() => onCalculateFee(svc.code)}>
                            <Calculator className="w-3 h-3 mr-1" /> Fee
                          </Button>
                          <Button variant="outline" size="sm" onClick={() => onGetTimeline(svc.code)}>
                            <Clock className="w-3 h-3 mr-1" /> Timeline
                          </Button>
                          <Button variant="outline" size="sm" onClick={() => { onSelectService(svc); onGetDocuments(svc.code); }}>
                            <FileCheck className="w-3 h-3 mr-1" /> Docs
                          </Button>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
};
